import "./index.css";

import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Grid,
  Input,
  List,
  Row,
  Typography,
  theme,
} from "antd";

import AppLayout from "../../components/Layout";
import { CiSearch } from "react-icons/ci";
import Courses from "./Courses";
import React from "react";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { useAuth } from "../../hooks/useAuth";

const { useBreakpoint } = Grid;
const { useToken } = theme;

const Home = () => {
  const token = useToken();
  const breakpoints = useBreakpoint();
  const { ...user } = useAuth();
  return (
      <Row justify={"space-between"}>
        <Col xs={24} md={24} lg={24} style={{ padding: breakpoints.lg ? "0px 10px" : '10px',}}>
          <Card className="card-search">
            <Typography className="card-title"
              
            >
              Olá, {user?.profile?.user}!
            </Typography>
            <Typography className="card-subtitle">
              Qual curso procura?
            </Typography>
            <div className="div-button">
              <Col xs={20} md={20} lg={20}>
                <Input
                  className="input-search"
                  placeholder="Qual curso procura?"
                />
              </Col>
              <Col xs={4} md={4} lg={4}>
                <Button
                  className="button-search"
                  icon={<CiSearch size={22} color="#FFF" />}
                />
              </Col>
            </div>
          </Card>
          <div style={{ width: "100%", marginTop: "40px" }}>
            <Courses />
          </div>
        </Col>
      </Row>
  );
};

export default Home;
